import React, {useEffect} from "react";
import {graphql} from "gatsby";
import parse from "html-react-parser";
import {Asset} from "../../../../plugins/gatsby-plugin-atollon";
import marqueeEffect from "../../../hooks/marquee-effect";
import {gsap} from "gsap";

const TitleClient = ({title, clients, theme}) => {
    useEffect(() => {
        marqueeEffect(gsap.utils.toArray(".title-client__marquees-wrapper"), {paused: false, repeat: -1,});
    }, [])

    return (
        <section className={`title-client ${theme || ''}`}>
            <div className='title-client__inner'>
                {title && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
            </div>
            <div className='title-client__marquees' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
                <div className='title-client__marquees-wrapper'>
                    {clients?.length > 0 && clients.map((el, i) => (
                        <div key={i} className='title-client__item'>
                            <Asset asset={el}/>
                        </div>
                    ))}
                </div>
                <div className='title-client__marquees-wrapper'>
                    {clients?.length > 0 && clients.map((el, i) => (
                        <div key={i} className='title-client__item'>
                            <Asset asset={el}/>
                        </div>
                    ))}
                </div>
                <div className='title-client__marquees-wrapper'>
                    {clients?.length > 0 && clients.map((el, i) => (
                        <div key={i} className='title-client__item'>
                            <Asset asset={el}/>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}

export default TitleClient

export const query = graphql`
fragment TitleClientProps on DatoCmsTitleClient {
  ... on DatoCmsTitleClient {
    id
    title
    clients {
      ...InternalAssetProps
    }
  }
}
`;